import { MeUser } from "../../../../../services/models/me-user";
import { InterviewsService } from "../../../../../services/interviews.service";
import { ActionCol } from "../../../../../shared/table-col-configs/action-col";
import { Type } from "@angular/core";
import { DetailButtonComponent } from "../../../../../shared/table-components/detail-button/detail-button.component";
import { OpenDetailCommand } from "../../../../../shared/commands/open-detail-command";
import { TextCol } from "../../../../records/models/columns/text-col";
import { ActionButtonsComponent } from "../../../../../shared/table-components/action-buttons/action-buttons.component";
import { ActionButtonsNoTextComponent } from "../../../../../shared/table-components/action-buttons-no-text/action-buttons-no-text.component";
import { CreateRecoveryPlanCommand } from "../../../../../shared/commands/create-recovery-plan-command";
import { IQuestion } from "src/app/interface/filters";
import { InterviewsV2Service } from "src/app/services/interviews-v2.service";
import { OpenInterviewDetailCommand } from "src/app/shared/commands/open-interview-detail-command";

export const INTERVIEW_SUMMARY_COLUMNS_ELASTIC = (user: MeUser, service: InterviewsService | InterviewsV2Service, question: IQuestion) =>
	[
		new ActionCol<any, Type<DetailButtonComponent<any>>, InterviewsService | InterviewsV2Service>(
			"surveyRequestId",
			true,
			"Survey Request Id",
			[new OpenInterviewDetailCommand()],
			DetailButtonComponent,
			true
		),
		new TextCol("brand", false, undefined, undefined, true, false),
		new TextCol("market"),
		new TextCol("dealerGroup"),
		new TextCol("dealer", false, undefined, undefined, false, false), //Main Company ID
		new TextCol("dealerName", undefined, undefined, undefined, true, undefined, undefined, true), // Supplier
		new TextCol("outlet"),// RRDI Code
		new TextCol("outletName"),
		new TextCol("agent"),
		new TextCol("agentName"),
		new TextCol("customerName", true, undefined, undefined, undefined, undefined, undefined, true),
		new TextCol("vin", true),
		new TextCol("interviewdate"),
		new TextCol("engine", false, undefined, undefined, true, false),
		new TextCol("modelComputed"),
		new TextCol("channel"),
		new TextCol("alertRaised", false, "alertRaised", undefined, true),
		new TextCol("promotionCode", undefined, "Promo Code - CCB / NRM Subtypes", undefined, true),
	//	new TextCol("orderCustomerTypeSource", undefined, undefined, undefined, true),
		new TextCol("orderCustomerType", undefined, "TCO/Typeutil", undefined, true),
	//	new TextCol("orderCustomerSubtypeSource", undefined, undefined, undefined, true),
		new TextCol("orderCustomerSubtype", undefined, "Customer subtype", undefined, true),
		new TextCol("rpDtStatus", undefined, undefined, undefined, true, undefined, undefined, false),
		new ActionCol<any, Type<ActionButtonsComponent<any>>, InterviewsService | InterviewsV2Service>(
			"rpCreateBtn",
			false,
			"hotAlertTable.rpStatus",
			[new CreateRecoveryPlanCommand<any, InterviewsService | InterviewsV2Service>(service)],
			ActionButtonsNoTextComponent,
			false
		),
	]